(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ugc-marquee"] && !Shopify.designMode) return;
  try {
    function initUgcMarqueeClones(root) {
    (root || document).querySelectorAll('[data-ugc-marquee-track]').forEach(function (track) {
      if (track.dataset.cloned === 'true') return;
      var original = track.querySelector('[data-ugc-marquee-group]');
      if (!original || !original.children.length) return;

      var cloneCount = parseInt(track.dataset.cloneCount || '3', 10);
      for (var i = 0; i < cloneCount; i++) {
        var clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-ugc-marquee-group');
        track.appendChild(clone);
      }
      track.dataset.cloned = 'true';
    });
  }

  initUgcMarqueeClones();
  document.addEventListener('shopify:section:load', function (event) {
    initUgcMarqueeClones(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
